/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconTooling = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 32 32"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 32px;
      `}
      {...props}
    >
      <g
        fill={fill}
        fillRule="evenodd"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
      >
        <path d="M6.121 30.056a3 3 0 0 1-4.242-4.243l8.485-8.48 4.243 4.243-8.486 8.48zM24.505 7.429l-12.02 12.02M27.333 7.43a2 2 0 1 1-2.828-2.83l3.536-3.533 2.828 2.826-3.536 3.536zM14.987 12.093l-4.054-4.06a4.997 4.997 0 0 0-1.116-5.358 4.944 4.944 0 0 0-2.986-1.411 3.99 3.99 0 0 1-5.498 5.501 4.961 4.961 0 0 0 6.764 4.096l3.102 3.102M17.983 20.747l3.366 3.365a5 5 0 1 0 2.828-2.828l-4.348-4.348" />
        <path d="M25.647 25.581a.5.5 0 1 1 .707.707.5.5 0 0 1-.707-.707" />
      </g>
    </svg>
  ),
);
